// Which deployment is this bundle running in? The same build serves production
// and staging; only the hostname differs.
export function isStagingHost(hostname) {
  const h = hostname === undefined ? (typeof window !== 'undefined' ? window.location.hostname : '') : hostname;
  return /^staging\./i.test(h || '');
}
